import React, { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../Testimonial/Testimonial.css";
import { GiCalculator } from "react-icons/gi";

gsap.registerPlugin(ScrollTrigger);

const testimonials = [
  {
    image:
      "https://img.freepik.com/free-photo/medium-shot-man-working-as-lawyer_23-2151054078.jpg?t=st=1736935572~exp=1736939172~hmac=188bb6ea502be5345f6a6db15f1ae3f5bf7b696c09ba430fac608c25e2f034cb&w=740",
    comment:
      "The CA team provided exceptional financial advice and assisted me in managing my tax matters with utmost professionalism. Their timely guidance helped me optimize my finances and comply with all legal obligations smoothly.",
    name: "XYZ",
  },
  {
    image:
      "https://img.freepik.com/free-photo/brunette-businesswoman-posing_23-2148142767.jpg?t=st=1736935651~exp=1736939251~hmac=32b7855e8a6ab0dd889d599574c62bfce450663035885c6aae1d12d5ddf3f714&w=740",
    comment:
      "I am incredibly thankful for their attention to detail in handling my business finances. They guided me through complex accounting challenges with ease. From tax planning to auditing, they were responsive and always put my interests first.",
    name: "XYZ2",
  },
  {
    image:
      "https://img.freepik.com/free-photo/portrait-smiling-charming-young-man-grey-t-shirt-standing-against-plain-background_23-2148213406.jpg?t=st=1736935520~exp=1736939120~hmac=58ee03ad71be0930a7e567b3f3331dc6ee299d44216a63d80a5d9f0c08ed7c44&w=740",
    comment:
      "Their expertise in tax advisory and financial planning is unmatched. I highly recommend their services! They understood my unique situation and provided insightful recommendations that helped me optimize my taxes and financial strategy.",
    name: "XYZ3",
  },
];

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonialRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".left-div", {
        scrollTrigger: {
          trigger: ".testimonial-section",
          start: "top 80%",
        },
        x: -100,
        opacity: 0,
        duration: 1,
        ease: "power2.out",
      });

      gsap.from(".right-div", {
        scrollTrigger: {
          trigger: ".testimonial-section",
          start: "top 80%",
        },
        x: 100,
        opacity: 0,
        duration: 1,
        ease: "power2.out",
      });
    }, testimonialRef);

    return () => ctx.revert(); // Cleanup GSAP context
  }, []);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1,
    );
  };

  const { image, comment, name } = testimonials[currentIndex];

  return (
    <div className="testimonial-section" ref={testimonialRef}>
      <div className="left-div">
        <img src={image} alt={name} className="client-image" />
      </div>
      <div className="right-div">
        <div className="decorated-heading-pctt">
          <GiCalculator className="react-icon-pctt" />
        </div>
        <div className="testimonial-header">
          <h3>Testimonial</h3>
          <img src="quote.svg" alt="icon" className="small-icon" />
        </div>
        <h2>What People Say About Us</h2>
        <p className="comment">{comment}</p>
        <div className="client-info">
          <p className="client-name">
            <strong>- {name}</strong>
          </p>
          <div className="navigation-buttons">
            <button onClick={prevTestimonial} className="nav-button">
              &#8592;
            </button>
            <button onClick={nextTestimonial} className="nav-button">
              &#8594;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
